import { useState, useEffect, Fragment } from 'react';
import { Modal, Badge } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { setAlert } from '../../actions/alert';
import { obtenerAsesoria } from '../../actions/psicologica';

const DetalleAsesoria = ({ asesoria, reestablecerAsesoria, detallesCompletosAsesoria }) => {

    const dispatch =  useDispatch();

    const { detalles_asesoria } = useSelector(state => state.psicologica);

    const [detalleModal, setDetalleModal] = useState(false);

    const [detallesData, setDetallesData] = useState({
        id: null, 
        nombre_asesor: null, 
        apellido_paterno_asesor: null, 
        apellido_materno_asesor: null, 
        nombre_joven: null, 
        apellido_paterno_joven: null, 
        apellido_materno_joven: null, 
        ultima_cita: null, 
        proxima_cita: null, 
        status: null, 
        url_perfil: null
    });

    /* Detalles completos */
    const handleDetalles = async () => {
        if(detallesData.id){
            detallesCompletosAsesoria(detallesData.id);
            handleCerrar();
        }else{
            dispatch(setAlert('Selecciona primero una asesoria', 'danger'));
        }
    }

    const handleCerrar = () => {
        setDetallesData({
            id: null, 
            nombre_asesor: null, 
            apellido_paterno_asesor: null, 
            apellido_materno_asesor: null, 
            nombre_joven: null, 
            apellido_paterno_joven: null, 
            apellido_materno_joven: null, 
            ultima_cita: null, 
            proxima_cita: null, 
            status: null, 
            url_perfil: null
        });
        setDetalleModal(false);
        reestablecerAsesoria(null);
    }

    /* Funciones generales */
    const handleStatus = (status) => {
        switch(status){
            case 0:
                return(
                    <h5><Badge pill bg="warning text-black">Pendiente</Badge></h5>
                )
            case 1:
                return(
                    <h5><Badge pill bg="success">Aprobada</Badge></h5>
                )

            case 2:
                return(
                    <h5><Badge pill bg="danger">Rechazada</Badge></h5>
                )
            default:
                return(
                    <h5><Badge pill bg="secondary">Sin cita</Badge></h5>
                )
                break;
        }
    }

    useEffect(() => {
        if(asesoria){
            setDetalleModal(true);

            dispatch(obtenerAsesoria(asesoria));
        }        
    }, [asesoria]);

    useEffect(() => {
        if(detalles_asesoria){
            setDetallesData({
                ...detallesData,
                id: detalles_asesoria?._id, 
                nombre_asesor: detalles_asesoria?.usuario?.nombre, 
                apellido_paterno_asesor: detalles_asesoria?.usuario?.apellido_paterno,  
                apellido_materno_asesor: detalles_asesoria?.usuario?.apellido_materno, 
                nombre_joven: detalles_asesoria?.joven?.nombre, 
                apellido_paterno_joven: detalles_asesoria?.joven?.apellido_paterno,  
                apellido_materno_joven: detalles_asesoria?.joven?.apellido_materno, 
                ultima_cita: detalles_asesoria?.ultima_cita, 
                proxima_cita: detalles_asesoria?.proxima_cita, 
                status: detalles_asesoria?.status,  
                url_perfil: detalles_asesoria.url_perfil_p || process.env.REACT_APP_PUBLIC_ROUTE + '/assets/images/perfil_placeholder.png'
            });
        }
    }, [detalles_asesoria]);

    return (
        <Fragment>
            <HelmetProvider>
                <Helmet>
                    <style>{`
                        .contenedor_imagen_perfil {
                            border-radius: 50%;
                            display: inline-block;
                            position: relative;
                            padding: 0px;
                            background: #fff;
                            border: 5px solid #111F62;
                            width: auto;
                            margin: auto;
                        }
                        
                        .contenedor_imagen{
                            position: relative;
                            width: 200px;
                            height: 200px;
                            overflow: hidden;
                            border-radius: 50%;
                        }

                        #imagen_perfil {
                            width: auto;
                            height: 100%;
                            display: block;
                            position: absolute;
                            margin: auto;
                            top: -100%;
                            right: -100%;
                            bottom: -100%;
                            left: -100%;
                        }
                    `}</style>
                </Helmet>
            </HelmetProvider>
            <Modal show={detalleModal} size="lg" backdrop="static" centered onHide={() => handleCerrar()}>
                <Modal.Header closeButton>
                    <Modal.Title>Detalles del asesorado</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-5 row">
                            <label className="contenedor_imagen_perfil">
                                <div className="contenedor_imagen">
                                    <img id="imagen_perfil" src={ detallesData?.url_perfil }/>
                                </div>
                            </label>
                        </div>

                        <div className="col-md-7 row">
                            <div className="col-md-12">
                                <label className="fw-bold">Jóven</label>
                                <p>{[detallesData?.nombre_joven, detallesData?.apellido_paterno_joven, detallesData?.apellido_materno_joven].join(' ')}</p>
                            </div>
                            
                            <div className="col-md-12">
                                <label className="fw-bold">Asesor</label>
                                <p>{detallesData?.nombre_asesor ? [detallesData?.nombre_asesor, detallesData?.apellido_paterno_asesor, detallesData?.apellido_materno_asesor].join(' ') : 'Sin definir'}</p>
                            </div>

                            <div className="col-md-6">
                                <label className="fw-bold">Última cita</label>
                                <p>{detallesData?.ultima_cita ? new Date(detallesData?.ultima_cita).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) + ' a las ' + new Date(detallesData?.ultima_cita).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }) : 'Sin definir'}</p>
                            </div>

                            <div className="col-md-6">
                                <label className="fw-bold">Próxima cita</label>
                                <p>{detallesData?.proxima_cita ? new Date(detallesData?.proxima_cita).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) + ' a las ' + new Date(detallesData?.proxima_cita).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }) : 'Sin definir'}</p>
                            </div>

                            <div className="col-md-12">
                                <label className="fw-bold">Status de próxima cita</label>
                                <p>{handleStatus(detallesData?.status)}</p>
                            </div>
                        </div>                    
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-primary" onClick={() => handleDetalles()}><i className="fas fa-eye fa-sm"></i> Más detalles</button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    )
}

export default DetalleAsesoria;